<template>
  <Main>
    <BaseTab class="quotation-list__tab px-0 mx-0">
      <v-row>
        <v-col cols="auto" class="quotation-list__col">
          <v-tab>COTAÇÕES</v-tab>
        </v-col>
        <v-col cols="auto" class="quotation-list__col">
          <v-tab>ACOMPANHAR CRÍTICAS</v-tab>
        </v-col>
        <v-spacer class="d-none d-sm-flex" />
        <v-col cols="12" sm="4" md="3" class="pb-md-0 d-none d-sm-flex">
          <BaseButton
            class="secondary white--text justify-start"
            width="100%"
            :to="{ name: 'add quotation' }"
          >
            <v-icon class="pr-sm-5 pr-0 pr-md-9">
              fa-plus
            </v-icon>
            NOVA COTAÇÃO
          </BaseButton>
        </v-col>
      </v-row>
      <v-tab-item class="pt-5">
        <v-row class="py-5 d-flex d-sm-none">
          <v-col cols="12" class="d-flex d-sm-none">
            <BaseButton
              class="secondary white--text justify-start"
              width="100%"
              :to="{ name: 'add quotation' }"
            >
              <v-icon class="pr-9">
                fa-plus
              </v-icon>
              NOVA COTAÇÃO
            </BaseButton>
          </v-col>
        </v-row>
        <QuotationTable />
      </v-tab-item>
      <v-tab-item class="pt-5">
        <v-row class="py-5 d-flex d-sm-none">
          <v-col cols="12" class="d-flex d-sm-none">
            <BaseButton
              class="secondary white--text justify-start"
              width="100%"
              :to="{ name: 'add quotation' }"
            >
              <v-icon class="pr-9">
                fa-plus
              </v-icon>
              NOVA COTAÇÃO
            </BaseButton>
          </v-col>
        </v-row>
        <CriticismTable />
      </v-tab-item>
    </BaseTab>
  </Main>
</template>
<script>
import QuotationTable from "../components/QuotationTable";
import CriticismTable from "../components/CriticismTable";
export default {
  name: "QuotationListGarantia",
  data: () => ({}),
  components: {
    QuotationTable,
    CriticismTable
  }
};
</script>
<style lang="sass">
.quotation-list__
  &col
    align-self: center
  &tab
    .v-tabs-bar
      height: 50px !important
      border-bottom: 2px solid #E5E5ED
    .v-tab
      font-size: 16px
      font-weight: 400
      text-transform: none !important
    .v-tab--active
     font-weight: 600 !important
    .v-slide-group__prev--disabled
      display: none !important
</style>
